// Federal Public Service Job Classifications
// Source: ~/backend/StaticData/fedPubServiceJobClassifications.js

import {
  translateJobClassification,
  type ClassificationLanguage,
} from "../i18n/classificationTranslations";

export const jobClassificationsHierarchical = {
  "STDNT": {
    name: "Student",
    subgroups: {
      "STDNT": "Student"
    }
  },
  "AI": {
    name: "Air Traffic Control",
    subgroups: {
      "AI": "Air Traffic Control",
      "AI-NOP": "Navigation Operations Personnel"
    }
  },
  "AO": {
    name: "Aircraft Operations",
    subgroups: {
      "AO": "Aircraft Operations",
      "AO-CAI": "Chief Aviation Instructor",
      "AO-ETP": "Electronic Test Pilot",
      "AO-HPS": "Helicopter Pilot Instructor"
    }
  },
  "CP": {
    name: "Commerce and Purchasing",
    subgroups: {
      "CO": "Commerce",
      "PG": "Purchasing and Supply"
    }
  },
  "CT": {
    name: "Comptrollership",
    subgroups: {
      "CT-EAV": "External Audit",
      "CT-FIN": "Financial Management",
      "CT-IAU": "Internal Audit"
    }
  },
  "CX": {
    name: "Correctional Services",
    subgroups: {
      "CX": "Correctional Services"
    }
  },
  "EB": {
    name: "Education and Library Science",
    subgroups: {
      "ED": "Education",
      "ED-EDS": "Education Support",
      "ED-EST": "Education, Skills and Training",
      "ED-LAT": "Language Teaching",
      "EU": "Educational Support",
      "EU-LAI": "Language Instruction",
      "EU-PEI": "Program and Education Instruction",
      "EU-TEA": "Teaching",
      "LS": "Library Science"
    }
  },
  "EC": {
    name: "Economics and Social Science Services",
    subgroups: {
      "EC": "Economics and Social Science Services"
    }
  },
  "EL": {
    name: "Electronics",
    subgroups: {
      "EL": "Electronics"
    }
  },
  "EX": {
    name: "Executive",
    subgroups: {
      "EX": "Executive"
    }
  },
  "FB": {
    name: "Border Services",
    subgroups: {
      "FB": "Border Services"
    }
  },
  "FS": {
    name: "Foreign Service",
    subgroups: {
      "FS": "Foreign Service"
    }
  },
  "HM": {
    name: "Human Resources Management",
    subgroups: {
      "OM": "Organization and Methods",
      "PE": "Personnel Administration"
    }
  },
  "IT": {
    name: "Information Technology",
    subgroups: {
      "IT": "Information Technology"
    }
  },
  "LC": {
    name: "Law Management",
    subgroups: {
      "LC": "Law Management"
    }
  },
  "LP": {
    name: "Law Practitioner",
    subgroups: {
      "LP": "Law Practitioner"
    }
  },
  "NR": {
    name: "Architecture, Engineering and Land Survey",
    subgroups: {
      "AR": "Architecture and Town Planning",
      "EN-ENG": "Engineering",
      "EN-SUR": "Land Survey"
    }
  },
  "PA": {
    name: "Program and Administrative Services",
    subgroups: {
      // New subgroups (current)
      "PA-EAA": "Executive Administrative Assistant",
      "PA-CMN": "Communications",
      "PA-PDM": "Program Development & Administration",
      "PA-PVO": "Program & Service Operations",
      "PA-RHB": "Rehabilitation & Reintegration",
      // Legacy subgroups (being phased out)
      "AS": "Administrative Services",
      "CM": "Communications",
      "CR": "Clerical and Regulatory",
      "DA": "Data Processing",
      "DA-CON": "Data Conversion",
      "DA-PRO": "Data Production",
      "IS": "Information Services",
      "OE": "Office Equipment",
      "OE-BEO": "Business Equipment Operation",
      "OE-CEO": "Computer Equipment Operation",
      "OE-DEO": "Data Entry Operation",
      "OE-MEO": "Microform Equipment Operation",
      "OE-MSE": "Mail Service Equipment",
      "PM": "Programme Administration",
      "PM-MCO": "Mediation and Conciliation Officer",
      "ST": "Secretarial, Stenographic, Typing",
      "ST-COR": "Court Reporter",
      "ST-OCE": "Office Composing Equipment",
      "ST-SCY": "Secretary",
      "ST-STN": "Stenographer",
      "ST-TYP": "Typist",
      "WP": "Welfare Programs"
    }
  },
  "PO": {
    name: "Law Enforcement Support and Police Operations Support",
    subgroups: {
      "PO": "Police Operations Support",
      "PO-IMA": "Intelligence and Investigative Support",
      "PO-TCO": "Telecommunications Operator",
      "LES-IM": "Law Enforcement Support - Intelligence",
      "LES-TO": "Law Enforcement Support - Telecommunications"
    }
  },
  "PR": {
    name: "Printing Services",
    subgroups: {
      "PR": "Printing Operations (Non-Supervisory)",
      "PR-BIN": "Bindery",
      "PR-COM": "Composition",
      "PR-MAI": "Mail",
      "PR-OFE": "Offset Equipment",
      "PR-OFO": "Offset Operations",
      "PR-PRC": "Press Camera"
    }
  },
  "RE": {
    name: "Research",
    subgroups: {
      "DS": "Defence Scientific Service",
      "HR": "Historical Research",
      "MA": "Mathematics",
      "SE": "Scientific Research",
      "SE-REM": "Research and Evaluation Methods",
      "SE-RES": "Research Scientist"
    }
  },
  "RM": {
    name: "Research Management",
    subgroups: {
      "RM": "Research Management"
    }
  },
  "RO": {
    name: "Radio Operations",
    subgroups: {
      "RO": "Radio Operations"
    }
  },
  "SH": {
    name: "Health Services",
    subgroups: {
      "DE": "Dentistry",
      "MD": "Medicine",
      "MD-MOF": "Medical Officer of Health",
      "MD-MSP": "Medical Specialist",
      "ND": "Nutrition and Dietetics",
      "ND-ADV": "Nutrition Advisor",
      "ND-DIT": "Dietitian",
      "ND-HME": "Home Economics",
      "NU": "Nursing",
      "NU-CHN": "Community Health Nursing",
      "NU-EMA": "Emergency Medical Assistant",
      "NU-HOS": "Hospital Nursing",
      "OP": "Occupational and Physical Therapy",
      "PH": "Pharmacy",
      "PS": "Psychology",
      "SW": "Social Work",
      "SW-CHA": "Child Care",
      "SW-SCW": "Social and Community Worker",
      "VM": "Veterinary Medicine"
    }
  },
  "SO": {
    name: "Ships' Officers",
    subgroups: {
      "SO": "Ships' Officers",
      "SO-FLP": "Fleet Planning",
      "SO-INS": "Instructor",
      "SO-MAO": "Marine Operations",
      "SO-RAD": "Radio Officer"
    }
  },
  "SP": {
    name: "Applied Science and Patent Examination",
    subgroups: {
      "AC": "Actuarial Science",
      "AG": "Agriculture",
      "BI": "Biological Sciences",
      "CH": "Chemistry",
      "FO": "Forestry",
      "MT": "Meteorology",
      "PC": "Physical Sciences",
      "SG": "Scientific Regulation",
      "SG-PAT": "Patent Examination",
      "SG-SRE": "Scientific Regulation"
    }
  },
  "SR": {
    name: "Ship Repair",
    subgroups: {
      "SR-APP": "Apprentice",
      "SR-BOB": "Boat Builder",
      "SR-EEW": "Electrical and Electronic Worker",
      "SR-ELE": "Elemental",
      "SR-EME": "Engine Room Mechanic",
      "SR-INM": "Instrument Mechanic",
      "SR-MAC": "Machinist",
      "SR-MAM": "Marine Mechanic",
      "SR-MAN": "Marine Electronics Technician",
      "SR-MAT": "Material Handler",
      "SR-MDO": "Ship Repair Machine Driving-Operating",
      "SR-MGT": "Management",
      "SR-MOC": "Ship Repair Machine Operating-Controlling",
      "SR-PIP": "Pipefitter",
      "SR-PLE": "Plumber",
      "SR-PRW": "Production Worker",
      "SR-QCW": "Quality Control Worker",
      "SR-SMW": "Sheet Metal Worker",
      "SR-SPS": "Ship Repair Specialist",
      "SR-WOW": "Wood Worker"
    }
  },
  "SV": {
    name: "Operational Services",
    subgroups: {
      "FR": "Firefighters",
      "GL": "General Labour and Trades",
      "GL-AIM": "Aircraft Maintenance",
      "GL-AMW": "Automotive Maintenance Worker",
      "GL-COI": "Cook",
      "GL-EIM": "Electronic Instrument Maintenance",
      "GL-ELE": "Elemental",
      "GL-GHW": "General Maintenance Worker",
      "GL-INM": "Instrument Maintenance",
      "GL-MAM": "Materials Maintenance",
      "GL-MAN": "Maintenance",
      "GL-MDO": "Mobile Equipment Operator",
      "GL-MOC": "Motor Vehicle Operator",
      "GL-MST": "Materials and Supplies Technician",
      "GL-PCF": "Parks, Conservation and Forestry",
      "GL-PIP": "Pipefitter",
      "GL-PRW": "Production Worker",
      "GL-SMW": "Sheet Metal Worker",
      "GL-VHE": "Vehicle Operator",
      "GL-WOW": "Wood Worker",
      "GS": "General Services",
      "GS-BUS": "Bus Operator",
      "GS-FOS": "Food Services",
      "GS-LAS": "Laundry and Cleaning Services",
      "GS-MES": "Messenger",
      "GS-MPS": "Mail and Pouch Services",
      "GS-PRC": "Program and Recreational Services",
      "GS-STS": "Stores",
      "HP": "Heating, Power and Stationary Plant Operations",
      "HS": "Hospital Services",
      "HS-HDO": "Hospital Domestic",
      "HS-PHS": "Personal Care Services",
      "LI": "Lightkeepers",
      "PR(S)": "Printing Operations (Supervisory)",
      "SC": "Ships' Crew",
      "SC-DED": "Deckhand",
      "SC-EQO": "Equipment Operator",
      "SC-ERD": "Engine Room Department",
      "SC-SPT": "Specialist",
      "SC-STD": "Steward"
    }
  },
  "TC": {
    name: "Technical Services",
    subgroups: {
      "DD": "Drafting and Illustration",
      "EG": "Engineering and Scientific Support",
      "GT": "General Technical",
      "PI": "Primary Products Inspection",
      "PI-CGC": "Canadian Grain Commission",
      "PY": "Photography",
      "TI": "Technical Inspection"
    }
  },
  "TR": {
    name: "Translation",
    subgroups: {
      "TR": "Translation"
    }
  },
  "UT": {
    name: "University Teaching",
    subgroups: {
      "UT": "University Teaching"
    }
  }
};

// Helper function to get all classification options in a flat list
export const getAllClassifications = (language: ClassificationLanguage) => {
  const classifications: { code: string; name: string; group: string }[] = [];
  
  Object.entries(jobClassificationsHierarchical).forEach(([, group]) => {
    Object.entries(group.subgroups).forEach(([subgroupCode, subgroupName]) => {
      classifications.push({
        code: subgroupCode,
        name: translateJobClassification(subgroupName, language),
        group: translateJobClassification(group.name, language)
      });
    });
  });
  
  return classifications.sort((a, b) => a.code.localeCompare(b.code));
};

// Helper function to get grouped classifications for optgroup dropdown
export const getGroupedClassifications = (language: ClassificationLanguage) => {
  return Object.entries(jobClassificationsHierarchical).map(([groupCode, group]) => ({
    groupCode,
    groupName: translateJobClassification(group.name, language),
    subgroups: Object.entries(group.subgroups).map(([code, name]) => ({
      code,
      name: translateJobClassification(name, language)
    }))
  })).sort((a, b) => {
    const studentLabel = language === "fr" ? "Étudiant" : "Student";

    // Force Student to be first in the list
    if (a.groupName === studentLabel) return -1;
    if (b.groupName === studentLabel) return 1;

    // otherwise normal alphabetical sort
    return a.groupName.localeCompare(b.groupName);
  });
};
